import React from 'react';
import { FormField } from '~/components/core';
import { PaymentProvider1BillingField } from '~/api-services/CustomerInfoService/types';
import BillingFieldComponentType from '~/components/features/AddFundsCardPaymentProvider1/BillingFieldComponentType';

type Props = {
    idx: number;
    fields: PaymentProvider1BillingField[];
    onChangeBillingField: Function;
};

export default function BillingFieldComponent({ idx, fields, onChangeBillingField }: Props) {
    const field = fields[idx];
    return (
        <FormField
            label={field.friendlyName}
            noTranslateLabel
            errors={[
                { text: 'please-fill-all-required-fields', visible: field.showValidation },
                { text: 'please-enter-valid-email', visible: field.showValidationEmail },
            ]}
        >
            <BillingFieldComponentType fields={fields} idx={idx} onChangeBillingField={onChangeBillingField} />
        </FormField>
    );
}
